<template>
  <Modal v-model="showModal" :scrollable="true" :mask-closable="false" :width="width" @on-cancel="closeModal">
    <p slot="header">
      <Icon type="md-create" />
      <span class="header-label">{{ title }}</span>
    </p>
    <div style="position: relative;">
      <Spin v-if="showLoading" fix />
      <Form ref="form" :label-width="90" :model="formFields" :rules="ruleValidate">
        <FormItem label="账号名:">
          <Input v-model="account" placeholder="请输入账号名, 账号名必须唯一..." size="small" disabled />
        </FormItem>
        <FormItem label="姓名:" prop="realName">
          <Input v-model="formFields.realName" placeholder="请输入会员姓名..." size="small" />
        </FormItem>
        <FormItem label="手机号:" prop="mobile">
          <Input v-model="formFields.mobile" placeholder="请输入手机号码..." size="small" />
        </FormItem>
        <FormItem label="身份证:" prop="identityCard">
          <Input v-model="formFields.identityCard" placeholder="请输入身份证..." size="small" />
        </FormItem>
        <FormItem label="性别:" prop="gender">
          <RadioGroup v-model="formFields.gender">
            <Radio :label="1" :true-value="1">
              男
            </Radio>
            <Radio :label="2" :true-value="2">
              女
            </Radio>
          </RadioGroup>
        </FormItem>
      </Form>
    </div>
    <div slot="footer">
      <Button
        type="primary"
        :disabled="showLoading"
        size="small"
        icon="ios-checkmark-circle-outline"
        :loading="submit"
        @click="saveOrUpdate"
      >
        保存
      </Button>
    </div>
  </Modal>
</template>

<script>
import request from '@/utils/request'
export default {
  name: 'MyProfile',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 500
    }
  },
  data() {
    return {
      account: '',
      loadingStatus: false,
      showLoading: false,
      submit: false,
      formFields: {
        realName: '',
        mobile: '',
        identityCard: '',
        gender: 1
      },
      blob: null
    }
  },
  computed: {
    action() {
      return this.$config.apiContextPath + '/me'
    },
    ruleValidate() {
      return {
        realName: [
          { required: true, message: '姓名不能为空!', trigger: 'blur' }
        ],
        mobile: [
          { required: true, type: 'string', message: '手机号不合法!', pattern: /^1(3|4|5|7|8)\d{9}$/, trigger: 'blur' }
        ],
        identityCard: [
          { type: 'string', message: '身份证不合法!', pattern: /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/, trigger: 'blur' }
        ]
      }
    },
    title() {
      return this.catch || '我的资料'
    },
    showModal: {
      get() { return this.visible },
      set(value) { }
    }
  },
  watch: {
    showModal(val) {
      this.$refs.form.resetFields()
      this.showLoading = true
      request({
        url: this.action,
        method: 'get'
      }).then(res => {
        this.showLoading = false
        const data = res.data
        this.account = data.name
        this.formFields = {
          realName: data.realName,
          gender: data.gender,
          mobile: data.mobile,
          identityCard: data.identityCard
        }
      }).catch(() => {
        // this.$Notice.error({
        //   title: '服务器数据请求失败',
        //   desc: '请求地址: ' + this.action + ', 错误信息: ' + error
        // })
        this.showLoading = false
      })
    }
  },
  mounted() {
  },
  methods: {
    saveOrUpdate: function() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submit = true
          request({
            url: this.action,
            method: 'PUT',
            data: this.formFields
          }).then(res => {
            this.loadingStatus = false
            // this.formFields = res.data
            this.$Notice.success({
              title: '数据保存成功',
              desc: '用户 `' + this.formFields.realName + '` 资料更新成功!'
            })
            this.submit = false
            this.closeModal(true)
          }).catch(error => {
            this.loadingStatus = false
            this.submit = false
            console.log(error)
          })
        }
      })
    },
    closeModal: function(changed = false) {
      this.formFields = {
        id: 0,
        name: '',
        realName: '',
        mobile: '',
        identityCard: '',
        gender: 1,
        roles: []
      }
      this.$emit('on-close', changed)
    }
  }
}
</script>

<style lang="less" scoped>
  .upload {
    .upload-icon {
      width: 270px;
      height: 205px;
      align-items: center;
      justify-content: center;
      display: flex;
      i {
        color: #3399ff;
      }
    }
  }
  .camera-note {
    color: #fd7e14;
    font-size: 8pt;
    margin-top: 10px;
  }
</style>
